import React, { useState, useEffect, useRef } from 'react'
import { toTitleCase } from '../helpers';
import testOptions from '../../data/testPublications.json';

const MediaExplorerSidePanel = ({ publication, setPublication }) => {
    const [search, setSearch] = useState('');
    const [options, setOptions] = useState([]);
    const isFirstRender = useRef(true);

    const searchPublication = toTitleCase(publication);

    useEffect(() => {
        if (searchPublication) {
            if (isFirstRender.current) {
                let newOptions   = testOptions.data.map(option => option[0]);
                const foundIndex = newOptions.indexOf(searchPublication);

                if (foundIndex !== -1) {
                    const matchedOption = newOptions[foundIndex];
                    newOptions.splice(foundIndex, 1);
                    newOptions.unshift(matchedOption);
                }

                newOptions = newOptions.slice(0, 10);

                setOptions(newOptions);
    
                isFirstRender.current = false;
            }
        } else {
            setOptions(testOptions.data.map(option => option[0]).slice(0, 10));
        }
    }, [publication]);

    const handleSearch = (e) => {
        setSearch(e.target.value);
    
        const currentSelection = testOptions.data.find(option => option[0].toLowerCase() === publication);
        let newOptions = testOptions.data
            .map(option => option[0])
            .filter(option => option.toLowerCase().includes(e.target.value.toLowerCase()));
    
        newOptions = newOptions.filter(option => option !== searchPublication);
    
        if (currentSelection) {
            newOptions.unshift(currentSelection[0]);
        }
    
        setOptions(newOptions);
    };

    const handlePublicationChange = (option) => {
        // make sure ref is set to false if page was loaded without a publication
        if (isFirstRender.current === true) isFirstRender.current = false;

        const newPublication = option.toLowerCase();

        if (newPublication === publication) {
            return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'mediaScopePublicationChange',
            publication: option
        });

        setPublication(newPublication);
        const newUrl = `/media-scope/${encodeURIComponent(option)}`;
        window.history.replaceState(null, '', newUrl);
    }

  return (
    <div className="media-explorer--side-panel">
        <h4>News Sources</h4>
        <input type="text" placeholder="Search By Keyword" value={search} onChange={handleSearch}/>
        <ul>
            {options.map((option) => (
                <li 
                    key={option}
                    className={publication === option.toLowerCase() ? 'media-explorer-publication active' : 'media-explorer-publication'}
                    onClick={() => handlePublicationChange(option)}
                >{option}</li>
            ))}
        </ul>
    </div>
  )
}

export default MediaExplorerSidePanel